var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 415.13 481.73",
    style: {
      enableBackground: "new 0 0 415.13 481.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#29AA64;}\n\t.st1{fill:#29313D;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M207.56,54.66c-73.87,0-133.75,59.88-133.75,133.75c0,73.87,59.88,133.75,133.75,133.75 s133.75-59.88,133.75-133.75C341.31,114.54,281.43,54.66,207.56,54.66z M147.5,123.28h119.77v31.95h-44.43l0.17,68.85h-30.91 l-0.17-68.85H147.5V123.28z M268.29,210.06c0,39.46-22.6,61.3-60.72,61.3c-38.12,0-60.72-21.84-60.72-61.3v-39.32h31.03v38.17 c0,25.48,11.11,36.01,29.88,36.01c18.96,0,29.88-10.54,29.88-36.01v-38.17h30.65V210.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M250.32,333.73v17.14c0,0-39.2-0.58-35.95,76.14c0,0-4.86,0.08-6.35,0.04c-0.13,0-0.28,0.01-0.46,0.01 c-0.17,0-0.33-0.01-0.46-0.01c-1.49,0.04-6.35-0.04-6.35-0.04c3.25-76.72-35.95-76.14-35.95-76.14V333.9 c13.35,4.48,27.65,6.9,42.51,6.9C222.36,340.8,236.83,338.31,250.32,333.73z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastWhite);
export default __webpack_public_path__ + "static/media/mast_white.ad83c37e4112140b5b09c3b3ba8948ad.svg";
export { ForwardRef as ReactComponent };